import React, { useContext } from "react"
import { StateContext } from "../el/provider"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import { PillLink, PillButton } from "../el/button"
import { twMerge } from "tailwind-merge"
import scrollTo from "gatsby-plugin-smoothscroll"
const ProdHero = props => {
  return (
    <div className="content z-10 overflow-hidden border-b bg-white">
      <div className="relative mx-auto max-w-screen-xl ">
        <div className="relative z-10 bg-white pb-8 sm:pb-16 md:pb-20 lg:w-full lg:max-w-2xl lg:pb-28 xl:pb-32">
          <main className="relative z-10 mx-auto max-w-screen-xl px-4 pt-10 sm:px-6 sm:pt-12 md:pt-16 lg:px-8 lg:pt-20 xl:pt-28">
            {props.fua && (
              <div className="mx-auto rounded-full shadow-sm mb-5 w-28 h-28 lg:hidden">
                <StaticImage
                  alt="FlAsk Us Anything!"
                  src="../../images/page/marketing/fua-logo.png"
                  placeholder="blurred"
                  className="rounded-full shadow-md"
                  imgClassName=""
                />
              </div>
            )}

            <div className="text-left sm:text-center lg:text-left">
              {props.children}
            </div>
          </main>
          {props.fua && (
            <div className="hidden shadow-md rounded-full lg:block w-48 h-48 absolute top-28 -right-36 z-50">
              <StaticImage
                alt="FlAsk Us Anything!"
                src="../../images/page/marketing/fua-logo.png"
                placeholder="blurred"
                className="shadow-lg rounded-full"
                imgClassName=""
              />
            </div>
          )}

          <svg
            className="absolute inset-y-0 right-0 z-0 hidden h-full w-48 translate-x-1/2 transform text-white lg:block"
            fill="currentColor"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <polygon points="50,0 100,0 50,100 0,100" />
            {/* <polygon points="0 0 50 0 0 100 0 0" /> */}
          </svg>
        </div>

        <div className="h-full w-full lg:absolute lg:right-0 lg:top-0 lg:w-1/2">
          <GatsbyImage
            image={props.gatsbyImageData}
            className={twMerge(["productHeaderImage", "staticOnLarge"])}
            imgClassName="h-56 w-full sm:h-72 md:h-96 lg:w-auto lg:h-full"
            alt={props.alt}
          />
        </div>
      </div>
    </div>
  )
}

const TechStack = props => {
  const { stateSample } = useContext(StateContext)
  const [sample, setSample] = stateSample // eslint-disable-line no-unused-vars
  return (
    <div className="mt-3 flex flex-col items-center sm:mt-4 md:flex-row md:justify-center lg:justify-start">
      {props.gi && (
        <PillLink
          square
          className="inline-flex md:mr-3"
          to={props.gi}
          color={props.color}
        >
          General Info
        </PillLink>
      )}
      {props.sort && (
        <PillLink
          square
          className="mt-3 inline-flex md:mr-3 md:mt-0"
          to={`/an${props.techQuery}`}
          color={props.color}
        >
          Technical Resources
        </PillLink>
      )}
      <PillLink
        square
        className="mt-3 inline-flex md:mr-3 md:mt-0"
        to="/form/samples"
        color={props.color}
        onClick={() => setSample(props.sample)}
      >
        Request A Sample
      </PillLink>
      {props.parts && (
        <PillButton
          square
          className="mt-3 inline-flex md:mt-0"
          color={props.color}
          onClick={() => scrollTo("#partNumSection")}
        >
          List of Parts
        </PillButton>
      )}
    </div>
  )
}
const Buttons = props => {
  return (
    <div
      className={twMerge([
        "mt-10 sm:flex sm:justify-center lg:justify-start",
        props.className,
      ])}
    >
      {props.children}
    </div>
  )
}
export { ProdHero, TechStack, Buttons }
